module.exports = __webpack_public_path__ + "img/Weapon_93.3a134d3f.png";